var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pos"},[_c('el-page-header',{attrs:{"title":_vm.title},on:{"back":_vm.goBack},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('strong',[_vm._v(_vm._s(_vm.content))])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }